import { render, staticRenderFns } from "./retentionHistory.vue?vue&type=template&id=d88d5c40&scoped=true&"
import script from "./retentionHistory.vue?vue&type=script&lang=js&"
export * from "./retentionHistory.vue?vue&type=script&lang=js&"
import style0 from "./retentionHistory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./retentionHistory.vue?vue&type=style&index=1&id=d88d5c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88d5c40",
  null
  
)

export default component.exports